/** @format */

import { AvailabilityMessage, ProductAvailability } from '@shared/data-access/interfaces';
import {
  ChangeDetectionStrategy,
  Component,
  Signal,
  computed,
  inject,
  input,
  output,
} from '@angular/core';
import {
  HomefieldIconLibraryModule,
  HomefieldIconsLibraryService,
  homefieldIconSignCircledCancelFill,
  homefieldIconSignCircledCheckFill,
} from '@dsg-tech/homefield-angular-icons';
import { PICKUP_MESSAGES, SHIPPING_MESSAGES } from '@shared/data-access/constants';

import { HmfActionTextComponent } from '@dsg-tech/homefield-angular';
import { TitleCasePipe } from '@angular/common';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'common-product-availability',
  imports: [TitleCasePipe, HmfActionTextComponent, HomefieldIconLibraryModule],
  templateUrl: './product-availability.component.html',
  styleUrl: './product-availability.component.scss',
})
export class ProductAvailabilityComponent {
  readonly homefieldIconsLibraryService = inject(HomefieldIconsLibraryService);

  readonly isComingSoon = input(false);
  readonly isOOS = input(false);
  readonly selectedStoreName = input<string | undefined>('');
  readonly showStoreNameInMessage = input(false);
  readonly clickSelectedStoreName = output();

  readonly productAvailabilityData = input<ProductAvailability | undefined>(undefined);
  readonly pickupMessage: Signal<AvailabilityMessage | undefined> = computed(() => {
    const data = this.productAvailabilityData();
    const inStoreInventoryMessage = data?.inStoreInventoryMessage;
    const storyInventoryMessageHasValue = inStoreInventoryMessage !== undefined;

    return inStoreInventoryMessage && storyInventoryMessageHasValue
      ? PICKUP_MESSAGES[inStoreInventoryMessage]
      : undefined;
  });

  readonly shippingMessage: Signal<AvailabilityMessage | undefined> = computed(() => {
    const data = this.productAvailabilityData();
    return data ? SHIPPING_MESSAGES[data.onlineInventoryMessage] : undefined;
  });

  constructor() {
    this.homefieldIconsLibraryService.registerIcons([
      homefieldIconSignCircledCheckFill,
      homefieldIconSignCircledCancelFill,
    ]);
  }
}
